export const enumDocumentCategorie = {
    PHOTOETUDIANT : "Photo étudiant",
    CVPDFETUDIANT : "CV Pdf étudiant",
    CVVIDEOETUDIANT : "CV Vidéo étudiant",
    PORTFOLIO : "Portfolio",
    LOGOENTREPRISE : "Logo Entreprise",
    LOGOENTREPRISESTRUCTURE : "Logo Entreprise Structure"
}